import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const PermissionGuard = ({ 
  children, 
  role = null,
  permission = null,
  fallback = null,
  hideWhenNoAccess = true
}) => {
  const { userRole, hasPermission } = useAuth();

  // Check role-based access
  if (role && userRole !== role) {
    return hideWhenNoAccess ? null : fallback;
  }

  // Check permission-based access
  if (permission && !hasPermission(permission)) {
    return hideWhenNoAccess ? null : fallback;
  }

  return children;
};

export default PermissionGuard;